import http from './HttpService';

const END_POINT = '/apps';

const list = (searchParams = {}) => {
  return http.get(END_POINT, { params: searchParams });
};

const add = (data) => {
  return http.post(END_POINT, data);
};

const update = (id, data) => {
  return http.put(`${END_POINT}/${id}`, data);
};

const remove = (id) => {
  return http.delete(`${END_POINT}/${id}`);
};

const changeStatus = (id, data) => {
  return http.patch(`${END_POINT}/${id}`, data);
};

const getIds = () => {
  return http.get(`${END_POINT}/get-ids`);
};

export default { list, add, update, changeStatus, remove, getIds };
